var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.125L6.7151 5.00223C6.80235 5.35333 6.846 5.52888 6.9321 5.6724C7.0083 5.79939 7.10825 5.90765 7.2255 5.99023C7.35795 6.0835 7.52 6.13079 7.8441 6.22531L10.5 7L7.8441 7.77469C7.52 7.86921 7.35795 7.9165 7.2255 8.00978C7.10825 8.09233 7.0083 8.2006 6.9321 8.32763C6.846 8.47111 6.80235 8.64667 6.7151 8.99778L6 11.875L5.2849 8.99778C5.19765 8.64667 5.154 8.47111 5.0679 8.32763C4.99168 8.2006 4.89175 8.09233 4.77453 8.00978C4.64205 7.9165 4.48 7.86921 4.1559 7.77469L1.5 7L4.1559 6.22531C4.48 6.13079 4.64205 6.0835 4.77453 5.99023C4.89175 5.90765 4.99168 5.79939 5.0679 5.6724C5.154 5.52888 5.19765 5.35333 5.2849 5.00223L6 2.125Z",
    fill: "#10A37F",
    stroke: "#10A37F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarPlus);
export default __webpack_public_path__ + "static/media/starPlus.c1d59c0fa1332437ce24c187f9443299.svg";
export { ForwardRef as ReactComponent };